import React from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { RecordItemType } from '../type';
import GameImage from '@/pages/home/components/GameImage';
// import defaultKol from '@/pages/intelligence/assets/svg/tipicon/kol-default.svg'
import defaultGame from '@/pages/intelligence/assets/imgs/common/game-default.svg';
interface GameContentType {
  cvm: RecordItemType;
  showClearIcon: boolean;
  entityType?: boolean;
  onClick: (cvm: RecordItemType) => void;
  onClearIcon: (cvm: RecordItemType) => void;
  defaultImg?: SVGAElement;
}
export default function GameContent(props: GameContentType) {
  const { cvm, showClearIcon, onClick, onClearIcon, entityType, defaultImg = defaultGame} = props;
  const { id, imgSrc, lineOneStr, lineTwoImg, lineTwoStr } = cvm || {};
  return (
    <div
      className="dbi-recent-flex"
      onClick={() => {
        if (onClick instanceof Function) {
          onClick(cvm);
        }
      }}
    >
      <div className="recent-left">
        <GameImage className="recent-img" entityType={entityType} src={imgSrc || defaultImg} />
        {/* <img src={imgSrc} className="recent-img" /> */}
        <div className="recent-left-context">
          <div className="recent-left-title">{lineOneStr}</div>
          <div className="recent-left-flex">
            {lineTwoImg && <img src={lineTwoImg} className="flex-county" />}
            {/* <SvgIcon type="other-county" className="flex-county" /> */}
            <span className="flex-text">{lineTwoStr}</span>
          </div>
        </div>
      </div>
      {showClearIcon && (
        <div
          className="recent-right"
          onClick={() => {
            if (onClearIcon instanceof Function) {
              onClearIcon(cvm);
            }
          }}
        >
          <SvgIcon type="clear-icon" className="recent-icon" />
        </div>
      )}
    </div>
  );
}
